import React, { createContext, useContext, useReducer } from 'react';

const BookingContext = createContext(null);

export const useBooking = () => useContext(BookingContext);

const initialState = {
  depDate: new Date().toISOString().split('T')[0],
  depTime: '08:00',
  origin: '',
  destination: '',
  roundTrip: false,
  retDate: new Date().toISOString().split('T')[0],
  retTime: '18:00',
  passengers: 1,
  luggage: 0,
};

const bookingReducer = (state, action) => {
  switch (action.type) {
    case 'UPDATE_FIELDS':
      return { ...state, ...action.payload };
    case 'RESET':
      return initialState;
    default:
      return state;
  }
};

export const BookingProvider = ({ children }) => {
  const [bookingData, dispatch] = useReducer(bookingReducer, initialState, () => {
    const stored = localStorage.getItem('bookingData');
    return stored !== null ? JSON.parse(stored) : initialState;
  });

  React.useEffect(() => {
    localStorage.setItem('bookingData', JSON.stringify(bookingData));
  }, [bookingData]);

  return (
    <BookingContext.Provider value={{ bookingData, dispatch }}>{children}</BookingContext.Provider>
  );
};
